// extracted by mini-css-extract-plugin
export default {"loginWrapper":"LoginLayout_loginWrapper__rhqn4"};